import { useContext } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AbilityContext } from '../../Context/Can';

export function PermissionRoute({ I: action, a: subject, children }) {
  const ability = useContext(AbilityContext);
  const { client_id } = useParams();
  const userRoles = useSelector(st => st.role?.data?.data);

  // Ability starts empty on page load; wait for rules to be populated before
  // making any access decision, otherwise direct URL navigation always redirects.
  if (!ability?.rules?.length) {
    return null;
  }

  if (ability.can(action, subject)) {
    return children;
  }

  const hasGreen = userRoles?.some(item => item.scope === 'green');
  return <Navigate to={hasGreen ? '/dashboard' : '/'} replace />;
}
